import { useTranslation } from 'react-i18next'

const ProductivityNoContent = () => {
  const { t } = useTranslation()
  return (
    <div className="productivity-no-content">
      <div className="productivity-no-value">--</div>
      <div className="warning">{t('general.homepage.productivity-no-hours')}</div>
    </div>
  )
}

export default ProductivityNoContent
